// Pure helper for the app-auth consent hand-off.
//
// sanitizeReturnUrl strips backslashes from a return_url before it is
// assigned to window.location.href. The prop serialization that delivers
// return_url into the consent Vue page can JSON-escape forward slashes as
// `\/` (e.g. `https:\/\/host\/oauth\/callback`). When such a string is
// assigned to window.location.href the browser rewrites every `\` to `/`,
// which DOUBLES the path slashes (`host//oauth//callback`) and 404s the
// callback. A URL never legitimately contains a backslash, so stripping
// them keeps the return URL well-formed.
//
// Factored out of AppAuthConsent.vue so the slash-doubling regression can
// be pinned by a pure unit test (tests/app-auth-return-url.spec.mjs).
export function sanitizeReturnUrl(returnUrl) {
  return String(returnUrl == null ? "" : returnUrl).replace(/\\/g, "");
}
